import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import { EventTypesProvider } from './contexts/EventTypesContext'
import EventWorkspace from './pages/EventWorkspace'
import EventOverviewPage from './pages/EventOverviewPage'
import EventSettingsPage from './pages/EventSettingsPage'
import ClassicEventPage from './pages/ClassicEventPage'
import EventsPage from './pages/EventsPage'
import HomeRedirect from './pages/HomeRedirect'
import EventVideosPage from './pages/EventVideosPage'
import ReelsPage from './pages/ReelsPage'
import LoginPage from './pages/LoginPage'
import ModerationPage from './pages/ModerationPage'
import PrizeRedemptionPage from './pages/PrizeRedemptionPage'
import UsersPage from './pages/UsersPage'
import UserDetailPage from './pages/UserDetailPage'
import EventTypesPage from './pages/EventTypesPage'
import EmailTemplatesPage from './pages/EmailTemplatesPage'
import SharedVideoPage from './pages/SharedVideoPage'
import AnalyticsPage from './pages/AnalyticsPage'
import ExportDownloadPage from './pages/ExportDownloadPage'
import { Toaster } from './components/ui/toaster'

export default function App() {
  return (
    <EventTypesProvider>
      <Routes>
        {/* Public route — no Layout, no auth */}
        <Route path="/share/:shareId" element={<SharedVideoPage />} />

        {/* Public route — no Layout, no auth. A restricted export renders the
            sign-in form itself; see ExportDownloadPage. */}
        <Route path="/exports/:exportId" element={<ExportDownloadPage />} />

        {/* Moderation runs without the app chrome. It is a full-viewport wall of
            video worked for hours at a time, and a second header above its own
            toolbar costs the videos a strip of every screen. The controls that
            header carried live in the moderation toolbar's overflow menu. */}
        <Route path="/events/:eventId/moderation" element={
          <ProtectedRoute><ModerationPage /></ProtectedRoute>
        } />

        {/* Admin routes — wrapped in Layout */}
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<ProtectedRoute> <HomeRedirect /> </ProtectedRoute>} />
              <Route path="/events" element={<ProtectedRoute> <EventsPage /> </ProtectedRoute>} />
              {/* One event's workspace: its sidebar beside every page of the
                  event. Moderation is the exception and lives above, outside
                  the app chrome. */}
              {/* The event page as it was before the workspace, kept as a
                  fallback; reached from the workspace sidebar only. */}
              <Route path="/events/:eventId/classic" element={<ProtectedRoute><ClassicEventPage /></ProtectedRoute>} />
              <Route path="/events/:eventId" element={<ProtectedRoute><EventWorkspace /></ProtectedRoute>}>
                <Route index element={<EventOverviewPage />} />
                <Route path="settings" element={<Navigate to="images" replace />} />
                <Route path="settings/:section" element={<EventSettingsPage />} />
                <Route path="videos" element={<EventVideosPage />} />
                <Route path="reels" element={<ReelsPage />} />
                <Route path="prizes" element={<PrizeRedemptionPage />} />
                <Route path="analytics" element={<ProtectedRoute eventAdminOnly><AnalyticsPage /></ProtectedRoute>} />
              </Route>
              <Route path="/event-types" element={<ProtectedRoute sysAdminOnly={true}> <EventTypesPage /> </ProtectedRoute>} />
              <Route path="/templates" element={<ProtectedRoute sysAdminOnly={true}> <EmailTemplatesPage /> </ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute sysAdminOnly={true} > <UsersPage /> </ProtectedRoute>} />
              <Route path="/users/:uid" element={<ProtectedRoute sysAdminOnly={true}><UserDetailPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        } />
      </Routes>
      <Toaster />
    </EventTypesProvider>
  )
}
